export { default as EducationalInstitutionsComponent } from './EducationalInstitutionsComponent';
export * from './config';
